module.exports = __webpack_public_path__ + "static/media/connector-logo_amazon-mwaa.8095d450.svg";